export default "__VITE_ASSET__BAxANJB$__"